const startButton = document.getElementById("start-btn");
const nextButton = document.getElementById("next-btn");
const showMeButton = document.getElementById("show-me-how-btn");
const questionContainerElement = document.getElementById("question21-container");
const questionElement = document.getElementById("question21");
const answerButtonsElement = document.getElementById("answer-buttons21");
const ctaElement = document.getElementById("cta21");


const questions21 = [
  {
    question:
      "How would your callers rate their phone experience?",
    answers: [
      { text: "Decent", correct: true },
      { text: "Average", correct: true },
      { text: "Needs improvement", correct: true },
    ],
  },
  {
    question: "How long do your customers wait between call transfers?",
    answers: [
      { text: "At least a minute", correct: true },
      { text: "Up to several minutes", correct: true },
      { text: "Don’t know", correct: true },
    ],
  },
  {
    question: "What do you need help with?",
    answers: [
      { text: "More accurate call routing", correct: true },
      { text: "Reducing customer wait times", correct: true },
    ],
  },
];


let shuffledQuestions21, currentQuestionIndex21;

startButton.addEventListener("click", startQuiz);
nextButton.addEventListener("click", () => {
  currentQuestionIndex21++;
  setNextQuestion();
  rotateGallery();
});

function startQuiz() {
  startButton.classList.add("hide");
  shuffledQuestions21 = questions21.sort();
  // () => Math.random() - 0.5;
  currentQuestionIndex21 = 0;
  questionContainerElement.classList.remove("hide");
  setNextQuestion();
}

function setNextQuestion() {
  resetState();
  if(currentQuestionIndex21 > questions21.length - 1){
    displaySuccess();
    return
  } 
  showQuestion(shuffledQuestions21[currentQuestionIndex21]);
}

function displaySuccess(){
  ctaElement.innerText =
  "Good news! DYL’s Call Transfer minimizes customer wait times by letting the employee transfer the call with just one click. Click below to find out how.";
  questionContainerElement.classList.add("hide");
  ctaElement.classList.remove("hide");
  showMeButton.classList.remove("hide");
}

function showQuestion(question) {
  questionElement.innerText = question.question;
  question.answers.forEach((answer) => {
    const button = document.createElement("h5");
    button.innerText = answer.text;
    button.classList.add("btn-block");
    button.classList.add("btn-primary");
    button.classList.add("p-2");
    button.classList.add("transition-3d-hover");
    button.classList.add("text-center");
    if (answer.correct) {
      button.dataset.correct = answer.correct;
    }
    button.addEventListener("click", selectAnswer);
    answerButtonsElement.appendChild(button);
  });
}

function resetState() {
  clearStatusClass(document.body);
  nextButton.classList.add("hide");
  while (answerButtonsElement.firstChild) {
    answerButtonsElement.removeChild(answerButtonsElement.firstChild);
  }
}

function selectAnswer(e) {
  const selectedButton = e.target;
  const correct = selectedButton.dataset.correct;
  setStatusClass(document.body, correct);
  Array.from(answerButtonsElement.children).forEach((button) => {
    setStatusClass(button, button.dataset.correct);
    selectedButton.style.backgroundColor = "green";
  });
    nextButton.classList.remove("hide");
}


function setStatusClass(element, correct) {
  clearStatusClass(element);
  if (correct) {
    element.classList.add("correct");
  } else {
    element.classList.add("wrong");
  }
}

function clearStatusClass(element) {
  element.classList.remove("correct");
  element.classList.remove("wrong");
}

let counter = 0,
  gallery = [
    "https://images.dyl.com/marketing-web/images/quiz/business-man-upset-phone-isnt-ringing.jpg",
    "https://images.dyl.com/marketing-web/images/quiz/three-arrows-on-bullseye-during-day.jpg",
    "https://images.dyl.com/marketing-web/images/quiz/woman-smiling-excited-with-yellow-background.jpg",
  ];
function rotateGallery() {
  document.getElementById("ImgGalleryCTQ").src = gallery[counter];
  counter++;
  if (counter >= gallery.length) {
    counter = 0;
  }
}

